/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {CECOModel} from '../../../../../../model'
import {getCECO, deleteCECO} from '../../../../../../services'
import {useCentral} from '../../../../../../../../hooks/useCentral'
import {ModalAddCECO} from '../modal/ceco'
import Swal from 'sweetalert2'
import {ShowSnackBar} from '../../../../../../../../util/functions'
const TableCECO: FC = () => {
  const {data, setData, setPagination, loading, setLoading, selectedOn, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useCentral()
  const [showModalNew, setShowModalNew] = useState(false)
  const [idPermission, setIdPermission] = useState<any>('')
  const [detailpermission, setDetailPermission] = useState<CECOModel | any>(null)

  const handleClear = () => {
    setIdPermission('')
  }
  const getProflieByUserList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getCECO(
        {recepcionadorServicioId: currentTabItem.idToEdit},
        pagination.currentPage,
      )
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  const handleEdit = (item: CECOModel) => {
    const filter = data.filter((detail) => detail.id === item.id)
    setDetailPermission(filter[0])
    setIdPermission(item.id)
    setShowModalNew(true)
  }
  useEffect(() => {
    getProflieByUserList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getProflieByUserList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  const columns: Column<CECOModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Área/Proyecto' />,
      accessor: 'area_Proyecto',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='CECO' />,
      accessor: 'centrodecosto',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('CECO/EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEdit(props.data[props.row.index])}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}{' '}
        </>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        const {data: response} = await deleteCECO(selectedOn[0])
        if (!response.error) {
          ShowSnackBar('Se eliminó satisfactoriamente')
          getProflieByUserList()
        } else {
          ShowSnackBar(response.message, 'error')
        }
        getProflieByUserList()
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleNew = () => {
    setShowModalNew(true)
  }
  return (
    <>
      {isAllowed('CECO/LISTAR') && (
        <KTCard shadow className='m-5'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('CECO/AGREGAR') && (
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
            )}
            {isAllowed('CECO/ELIMINAR') && (
              <button
                type='button'
                className='btn btn-primary me-3'
                disabled={selectedOn.length < 1}
                onClick={handleDelete}
              >
                Eliminar
              </button>
            )}
          </div>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
          <ModalAddCECO
            show={showModalNew}
            setShow={setShowModalNew}
            getProflieByUserList={getProflieByUserList}
            detailpermission={detailpermission}
            idPermission={idPermission}
            setIdPermissionList={handleClear}
          />
        </KTCard>
      )}
    </>
  )
}

const TableCECOWrapper = () => {
  return (
    <KTableProvider>
      <TableCECO />
    </KTableProvider>
  )
}
export {TableCECOWrapper}
